import Countdown2 from './Countdown2'
export default Countdown2
